import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, API_BASE } from "@/lib/kfmApi";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function AdminVoicePreviews() {
  const [voices, setVoices] = useState(null);

  useEffect(() => {
    api.get("/admin/tts/voice-previews").then(({ data }) => setVoices(data.voices)).catch(() => setVoices([]));
  }, []);

  return (
    <div className="min-h-screen bg-[#07090E] px-6 py-10">
      <div className="max-w-lg mx-auto space-y-6">
        <Link to="/settings" data-testid="voice-previews-back" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-slate-200">
          <ArrowLeft className="w-4 h-4" strokeWidth={1.75} /> Back
        </Link>
        <div>
          <h1 className="text-2xl text-white">Premium voice previews</h1>
          <p className="text-sm text-slate-400 mt-1">Each reads Psalm 23:1-3. Pick which ones go into the subscriber voice picker.</p>
        </div>
        {voices === null && (
          <div className="flex justify-center py-10"><Loader2 className="w-5 h-5 text-[#00E5FF] animate-spin" /></div>
        )}
        <div className="space-y-3">
          {(voices || []).map((v) => (
            <div key={v.id} data-testid={`voice-preview-${v.id}`} className="rounded-2xl bg-[#0E131F] border border-[#1E273D] p-4 space-y-2">
              <div>
                <div className="text-sm font-medium text-slate-200">{v.id}</div>
                <div className="text-xs text-slate-500">{v.description}</div>
              </div>
              <audio controls className="w-full h-9" src={`${API_BASE}/admin/tts/voice-previews/${v.id}.mp3`} data-testid={`voice-audio-${v.id}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
